import script from "./DoctorProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoctorProfile.vue?vue&type=script&setup=true&lang=ts"

import "./DoctorProfile.vue?vue&type=style&index=0&id=8ed2016e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ed2016e"]])

export default __exports__